import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'showTable' })
export class ShowTablePipe implements PipeTransform {
  transform(items: any[]): any[] {
    return items.filter((it) => it.showTable);
  }
}
